import React, { useContext, useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";
import { BsChevronDown } from "react-icons/bs";
import { BsPerson } from "react-icons/bs";
import { BsCash } from "react-icons/bs";

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem("theme");

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user?.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `Hi Friends, Play MannatLudo Ludo and earn 10000 daily. Download Indian App MannatLudo
  बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
   दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा
  
    NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
    100% भरोसेमंद प्लेटफार्म । 24 hours support https://MannatLudo.co/login/${user?.referral_code}
    
    Your ReferralCode is -${user?.referral_code}.`;

  // language

  const translations = {
    hi: {
      referral: "आपकी रेफरल कमाई",
      referPerson: "आमंत्रित किये दोस्त | ",
      referEarn: "रेफरल कमाई  ",
      referCode: "रेफरल कोड ",
    },
    en: {
      referral: "Your Referral Earnings",
      referPerson: "Referred Players",
      referEarn: "Referral Earning",
      referCode: "Referral Code",
    },
  };

  // change theme

  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "black",
  };
  const styles1 = {
    color: theme === "light" ? "black" : "white",
  };

  return (
    <>
      {/* <Header user={user} /> */}
      <div style={styles}>
        <div
          className="leftContainer pt-5 mt-3"
          style={{ ...styles, minHeight: "100vh", height: "100%" }}
        >
          <section className="refer-earn-premium ">
            {/* Hero Header Card */}
            <div className="refer-hero-card">
              <div className="hero-text-side">
                <span className="hero-badge">Special Program</span>
                <h1 className="hero-title">
                  Refer & <span className="text-gradient">Earn</span>
                </h1>
                <p className="hero-desc">
                  Share the joy with friends and unlock exclusive cash rewards
                  for every sign-up!
                </p>
              </div>
              <div className="hero-image-side">
                <img
                  src="/images/refer.png"
                  alt="Refer and Earn"
                  className="floating-img"
                />
              </div>
            </div>

            {/* Interactive Code Section */}
            <div className="referral-share-box">
              <p className="share-label">{translations[language].referCode}</p>
              <div className="code-capsule">
                <code className="main-code">{user?.referral_code}</code>
                <button className="copy-trigger" onClick={(e) => copyCode(e)}>
                  COPY
                </button>
              </div>
            </div>
            <div className="whatsapp_share_btn">
              <a
                href={`whatsapp://send?text=Play%20On%20MannatLudo%20%0A%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A4%82%E0%A5%A4%0A%0AAuto%20Deposit%20%26%20Auto%20Withdrawal%0A%0AInstant%20Withdrawal%20Via%20UPI%2FBank%2FWallet%20%0A%0ACommission%205%25%20Only%0AReferral%20commission%203%25%0A%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BC%E0%A5%89%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%0A%0A24x7%20Live%20Chat%20%26%20Call%20Support%0A%0Ahttps%3A%2F%2FMannatLudo.co%2Flogin%2F${user?.referral_code}`}
              >
                <BsWhatsapp className="icons" />
                <span class="ml-2">Whatsapp</span>
              </a>
            </div>

            <div className="performance-divider">
              <span>Your Performance</span>
            </div>

            {/* Stats Dashboard */}
            <div className="stats-dashboard">
              <div className="dashboard-card users-card">
                <div className="dashboard-content">
                  <p className="dashboard-label">
                    {translations[language].referPerson}
                  </p>
                  <h2 className="dashboard-value">
                    {user?.referral_user?.length}
                  </h2>
                </div>
                <div className="dashboard-icon-bg">
                  <img src="/images/win-cash.png" alt="win-cash" />
                </div>
              </div>

              <div className="dashboard-card earnings-card">
                <div className="dashboard-content">
                  <p className="dashboard-label">
                    {translations[language].referEarn}
                  </p>
                  <h2 className="dashboard-value">₹{user?.referral_earning}</h2>
                </div>
                <div className="dashboard-icon-bg">
                  <img src="/images/redeems.png" alt="Earning" />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
